import { Box } from "@mui/material";

import { FailedFiles, FileProgress } from "@/components";
import { TrackingFile } from "@/hooks";

interface TrackingFilesListProps {
  loadingFiles: TrackingFile[];
  failedFiles: TrackingFile[];
}

export function TrackingFilesList({ loadingFiles, failedFiles }: TrackingFilesListProps) {
  if (loadingFiles.length === 0 && failedFiles.length === 0) {
    return null;
  }

  return (
    <Box width="50%">
      {loadingFiles.length > 0 && <FileProgress files={loadingFiles} />}

      {failedFiles.length > 0 && <FailedFiles files={failedFiles} />}
    </Box>
  );
}
